import * as React from 'react';
import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { $ElementProps } from '../../../@types/utils';
import Icon from '../Icon';

import styles from './Link.module.scss';

export type Props<T extends React.ElementType> = Omit<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  'as'
> &
  $ElementProps<T> & {
    icon?: FontAwesomeIconProps['icon'];
    as?: T;
  };

export const Link = React.forwardRef(
  <T extends React.ElementType = 'a'>(
    {
      className,
      icon,
      children,
      disabled,
      as: Component = 'a',
      ...props
    }: Props<T>,
    ref: React.ForwardedRef<HTMLAnchorElement>,
  ) => (
    <Component
      className={classNames(styles.link, { disabled }, className)}
      ref={ref}
      {...props}
    >
      {icon && <Icon className={styles.icon} icon={icon} />}
      {children}
    </Component>
  ),
);

export default Link;
